module.exports = __webpack_public_path__ + "static/media/backvideo.a19ade19.mp4";